import { hasPermission } from 'services/user/permissions';

/**
 * Map of brikk IDs to their required permissions
 * Format: { brikkId: [{ resource: 'permission-key', action: 'action-type' }] }
 * Brikk is shown if the user has at least one of the listed permissions.
 */
const BRIKK_PERMISSIONS = {
  A06: [{ resource: 'admin-address', action: 'read' }], // ServiceReport brikk
  A21: [
    { resource: 'admin-users', action: 'read' },
    { resource: 'system-admin', action: 'read' },
  ], // UserAdministration brikk
};

/**
 * Filter brikks based on user permissions
 * Brikks without permission requirements will always be shown
 * @param {Array} brikks - Array of brikk objects
 * @param {Object} permissions - User permissions object
 * @returns {Array} - Filtered array of brikks
 */
export const validateBrikksByPermissions = (brikks, permissions) => {
  if (!permissions || Object.keys(permissions).length === 0) {
    // If no permissions object, filter out all permission-protected brikks
    return brikks.filter((brikk) => !BRIKK_PERMISSIONS[brikk.id]);
  }

  return brikks.filter((brikk) => {
    const permissionRequirements = BRIKK_PERMISSIONS[brikk.id];

    // If no permission requirement, show the brikk
    if (!permissionRequirements) {
      return true;
    }

    // Check if user has at least one of the required permissions
    return permissionRequirements.some(({ resource, action }) => hasPermission(permissions, resource, action));
  });
};
